// extracted by mini-css-extract-plugin
export default {"form":"ChangeForm__form--D_x","error":"ChangeForm__error--35u","captcha":"ChangeForm__captcha--iGk"};